import React, { useState, useRef } from "react";
import classNames from "classnames";

import { AppHeader } from "../../components/headers/header";
import { AppFooter } from "../../components/footers/footer";
import { useAuth } from "../../services/authentication/authentication.context";
import { LoadingIndicator } from "../../components/utils/loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  faImage } from "@fortawesome/free-solid-svg-icons";

import "../../styles/infos.css";
import "../../styles/blog-create.css";
import { serverUrl } from "../../_helpers/config";

export const CreateNewImage = () => {
    const { token, isLoading, userData, logoutUser} = useAuth();

  
    const inptBox = useRef();

    const [detail, setDetail] = useState(null);
    const [imageUri, setImageUri] = useState(null);
    const [imageFile, setImageFile] = useState(null);
    
    

    const coverRef = React.useRef(); 

    
    const addImage = (e) => {
        let image = e.target.files[0];
        setImageFile(image);
        setImageUri(URL.createObjectURL(image));
    }

    const clickFile = (e) => {
        coverRef.current.click();
    }

    
    const data = {
        image: imageFile,
        detail,
    }

    const createFormData = (d) => {
        const formData = new FormData();

        formData.append("image", d?.image);
        formData.append("detail", d?.detail);

        return formData;
    }

    const uploadImage = async (d, tk) => {
        try {
           const response = await fetch(`${serverUrl}/newgallery`, {
            method: "POST",
            mode: "cors",
            headers: {
                "Accept": "application/json",
                "authorization": `Bearer ${tk}`
            },
            body: createFormData(d)
           });
           const res = await response.json();
           console.log(res);
           alert(res.message); 
        } catch (e) {
            console.log({error: e})
        }
    } 

    
   
    return (
        <div className="app-body">
            <AppHeader data={userData} auth={token} signout={() => logoutUser(token)} />
             {isLoading && <LoadingIndicator />}
            <main className={classNames("info-page", "app-main")}>   
                <div 
                    className={classNames({"page-body": true})} 
                    style={{display: "flex", justifyContent: "center"}}
                > 
                    <div className={classNames({"blog-form": true })} ref={inptBox}>
                   
                        <div className="cover-img" id="cover">
                            <img src={imageUri ? imageUri : ""} id="cover-img" className="cover-picture" alt="" />
                            <input 
                                type="file" 
                                className="select-cover" 
                                onChange={(e) => addImage(e)}
                                ref={coverRef} 
                            />
                            <button 
                                className={classNames("file-select", "tbr-btn")} 
                                onClick={() => clickFile()}
                            >
                                <span className="lbl">Add cover image</span>
                                <FontAwesomeIcon icon={faImage} className="file-img" />
                            </button>
                        </div>
                        <input 
                            type="text" 
                            id="image-detail" 
                            className="title" 
                            placeholder="Enter image title here"
                            onChange={(e) => setDetail(e.target.value)}
                        />
                        
                        <button 
                            className="blog-create-btn" 
                            onClick={() =>{ uploadImage(data, token)}}
                        >
                            Save Image
                        </button>
                    </div>
                    
                </div>
            </main>
            <AppFooter />
        </div>
    );
}
